import { useModal } from 'vue-final-modal';
import { DistributionList } from '../ui';

export function useDocumentList() {
  const modal = useModal({
    component: DistributionList,
    attrs: {
      // @ts-ignore
      clickToClose: false,
      escToClose: false,
      title: 'Lista de Distribuição',
      onClose: () => modal.close(),
    },
  });

  const openDistributionList = () => {
    console.log('openDistributionList');
    modal.open();
  };

  const closeDistributionList = () => {
    console.log('closeDistributionList');
    modal.close();
  };

  return {
    openDistributionList,
    closeDistributionList,
  };
}
